<template>
    <Select v-model="nValue" @on-query-change="selChange" clearable :disabled="disabled">
        <Option v-for="item in dictItemList" :value="item.dictValue" :key="item.dictValue">{{ item.dictName }}</Option>
    </Select>
</template>

<script>
  export default {
    props:{
      value:{
        required:true,
      },
      dictCode:{
        required:true,
        type:String
      },
      disabled:{
        required:false,
        type:Boolean
      }
    },
    data () {
      return {
        dictItemList:[],
      }
    },
    mounted() {
      this.init();
    },
    computed: {
      nValue:{
        get:function(){
          return this.value + '';
        },
        set:function(value){
          this.$emit('input',value);
        }
      }
    },
    methods: {
      /**
       * 初始化
       */
      init() {
        this.query();
      },
      /**
       * 查询字典
       */
      query() {

        let _this = this;
        this.axios.post(this.api.dataDictApi+'/select', {dictCode:this.dictCode}).then(function(response) {
          var result = response.data;
          if (result.meta.code == 0) {
            _this.dictItemList = result.data;
            _this.$emit("get-values", result.data);
            // _this.dictItemList.unshift(all)
          } else {
            _this.$Message.warning(result.meta.message);
          }
        });
      },
      selChange(){
        this.$emit("select-change");
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/select/src/select.vue